import angular from 'angular'
import utils from 'utils'
import formPage from './view/invoiceForm.html'

const invoiceFormModule = angular.module('app.input.electronImage.contractInvoice.InvoiceForm', [])

export default invoiceFormModule.name
function getInvoiceTypeFromCode(invoiceCode) {
    if (!invoiceCode || invoiceCode.length < 8) {
        return ''
    }
    const strEighth = invoiceCode.substring(7, 8)
    const code = ['144031539110', '131001570151', '133011501118', '111001571071']
    for (let i = 0; i < code.length; i += 1) {
        if (invoiceCode === code[i]) {
            return '51'
        }
    }
    if (invoiceCode.length === 12) {
        const str1st = invoiceCode.charAt(0)
        const strLast = invoiceCode.substring(10, 12)
        if (str1st === '0') {
            if (strLast === '11') {
                return '51'
            }
            if (strLast === '04' || strLast === '05') {
                return '2'
            }
            if (strLast === '06' || strLast === '07') {
                return '41'
            }
            if (strLast === '12') {
                return '14'
            }
            if (strLast === '17') {
                return '15'
            }
        } else if (strEighth === '2') {
            return '12'
        }
    } else if (invoiceCode.length === 10) {
        // 第八位1或5为专用发票
        if (strEighth === '1' || strEighth === '5') {
            return '0'
        } if (strEighth === '3' || strEighth === '6') { // 第八位3或6为普通发票
            return '2'
        } if (strEighth === '2' || strEighth === '7') { // 第八位2或7为货运发票
            return '11'
        }
    }
    return ''
}

function genInvoiceForm() {
    return {
        template: formPage,
        transclude: true,
        scope: {
            invoice: '=',
            mode: '@',
            errorFields: '<',
        },
        replace: true,
        controller: ['$scope', '$element', 'httpRequest', 'globalFn', 'formvalidateApi',
            ($scope, $element, httpRequest, globalFn, formvalidateApi) => {
                $scope.validateRule = {
                    invoiceType: [{
                        erromsg: '发票代码格式错误，发票种类匹配失败',
                        condition(value) {
                            if (value) {
                                return getInvoiceTypeFromCode($scope.invoice.invoiceCode) !== value
                            }
                            return true
                        },
                    }],
                    invoiceCode: [{
                        erromsg: '发票代码格式错误',
                        condition(value) {
                            return !(/^\d*$/.test(value) || !getInvoiceTypeFromCode($scope.invoiceCode))
                        },
                    }],
                    invoiceNumber: [{
                        erromsg: '发票号码格式错误',
                        condition(value) {
                            return !/^[\d]{8}$/.test(value)
                        },
                    }],
                    checkCode: [{
                        erromsg: '校验码格式错误，请填写校验码后六位',
                        condition(value) {
                            if (!$scope.needCheckCode) {
                                return false
                            }
                            return (!/^\d+$/.test(value) || value.length !== 6)
                        },
                    }],
                    totalAmt: [{
                        erromsg: '开票金额格式错误',
                        condition(value) {
                            return value && !utils.regExpTest(value, 'taxAmount')
                        },
                    }],
                    totalTaxamt: [{
                        erromsg: '开票税额格式错误',
                        condition(value) {
                            return value && !utils.regExpTest(value, 'taxAmount')
                        },
                    }],
                    saleCreditCode: [{
                        erromsg: '销方税号格式错误',
                        condition(value) {
                            return value && !globalFn.checkTax(value)
                        },
                    }],
                    custCreditCode: [{
                        erromsg: '购方税号格式错误',
                        condition(value) {
                            return value && !globalFn.checkTax(value)
                        },
                    }],
                }
                $scope.invoiceTypeChange = function invoiceTypeChange() {
                    $scope.needCheckCode = $scope.invoice.invoiceType === '2'
                    || $scope.invoice.invoiceType === '14'
                    || $scope.invoice.invoiceType === '51'
                }
                $scope.invoiceCodeChange = function invoiceCodeChange() {
                    $scope.invoice.invoiceType = getInvoiceTypeFromCode($scope.invoice.invoiceCode)
                    $scope.needCheckCode = $scope.invoice.invoiceType === '2'
                    || $scope.invoice.invoiceType === '14'
                    || $scope.invoice.invoiceType === '51'
                    if ($scope.invoice.invoiceType) {
                        $(document.invoiceForm.invoiceType).trigger('click')
                    }
                }
                $scope.init = function init() {
                    $scope.checkError = {}
                    const typecodeArrStr = '["ivat_inv_type"]'
                    httpRequest.get_dictByTypeArr(typecodeArrStr).then((res) => {
                        $scope.dictionary = $.extend($scope.dictionary, res.data.value)
                    })
                    $element.find('#invoice-form-date').datetimepicker({
                        autoclose: true,
                        minView: 'month',
                        language: 'zh-CN',
                        format: 'yyyy-mm-dd',
                        forceParse: 0,
                        pickTime: false,
                        pickerPosition: 'bottom-right',
                    })
                    // $scope.validateOK = $scope.invoice.status === '校验通过'
                }
                $scope.$watch('invoice', () => {
                    // 翻页切换发票清除校验提示
                    formvalidateApi.clear()
                    if ($scope.invoice) {
                        $scope.validateOK = $scope.invoice.status === '校验通过'
                        $scope.needCheckCode = $scope.invoice.invoiceType === '2' || $scope.invoice.invoiceType === '51'
                    }
                })
                $scope.init()
            }],
    }
}
invoiceFormModule.directive('invoiceForm', genInvoiceForm)



// WEBPACK FOOTER //
// ./src/app/input/electronImage/contractEntering/invoiceForm.js